import api from '../../../api'
import { executeResponseError } from '../../../helpers'
import { getPositionsData } from '../positions/actions'
import {setSidebarIsOpen} from '../sidebar/actions'

export const ORDER_TRADE_SELL_BUY = 'ORDER_TRADE_SELL_BUY'
export const ORDER_NEW_TRADE = 'ORDER_NEW_TRADE'
export const ORDER_SET_STOP_LOSS = 'ORDER_SET_STOP_LOSS'
export const ORDER_SET_TAKE_PROFIT = 'ORDER_SET_TAKE_PROFIT'
export const ORDER_SET_PIP = 'ORDER_SET_PIP'
export const ORDER_SET_USED_MARGIN = 'ORDER_SET_USED_MARGIN'
export const ORDER_SET_EXECUTION_ENTRY_RATE = 'ORDER_SET_EXECUTION_ENTRY_RATE'
export const ORDER_SET_LOT = 'ORDER_SET_LOTS'
export const ORDER_SET_SL_LINE = 'ORDER_SET_SL_LINE'
export const ORDER_SET_TP_LINE = 'ORDER_SET_TP_LINE'

export const setOrderTradeSellBuy = (data) => {
	return {
		payload: data,
		type: ORDER_TRADE_SELL_BUY
	}
}

export const setExecutionEntryRate = (data) => {
	return {
		payload: data,
		type: ORDER_SET_EXECUTION_ENTRY_RATE
	}
}

export const setNewPendingOrder = (data, accessToken, userId, alert) => {
	return async dispatch => {
		try {
			const res = await api.orders.setPendingOrder(data, accessToken)
			if (res.data) {
				dispatch(getPositionsData(userId, accessToken, alert))
			}
			return res.data
		} catch (e) {
			const error = executeResponseError(e, 'Getting trading hours data error')
			throw new Error(error || '')
		}
	}
}

export const setUpdatePendingOrderAction = (data, accessToken, userId, alert) => {
	return async dispatch => {
		try {
			const res = await api.orders.setUpdatePendingOrder(data, accessToken)
			if (res.data) {
				dispatch(getPositionsData(userId, accessToken, alert))
			}
			return res.data
		} catch (e) {
			const error = executeResponseError(e, 'Update pending order error')
			throw new Error(error || '')
		}
	}
}

export const setUpdateOpenTradeAction = (data, accessToken, userId, tradeId, alert) => {
	return async dispatch => {
		try {
			const res = await api.orders.setUpdateOpenTrade(data, accessToken, tradeId)
			if (res.data) {
				dispatch(getPositionsData(userId, accessToken, alert))
			}
			return res.data
		} catch (e) {
			const error = executeResponseError(e, 'Update open trade error')
			throw new Error(error || '')
		}
	}
}

export const setNewOpenTrade = (data, accessToken, userId) => {
	return async dispatch => {
		try {
			const res = await api.orders.setOpenTrade(data, accessToken)
			if (res.data) {
				dispatch(getPositionsData(userId, accessToken, alert))
			}
			return res.data
		} catch (e) {
			const error = executeResponseError(e, 'Open trade error')
			throw new Error(error || '')
		}
	}
}

export const setClosePendingAction = (data, accessToken, isAuthorized, alert) => {
	return async dispatch => {
		try {
			const res = await api.orders.setClosePending(data, accessToken)
			if (res.data) {
				dispatch(getPositionsData(isAuthorized, accessToken, alert))
			}
			return res.data
		} catch (e) {
			const error = executeResponseError(e, 'Set close pending trade error')
			throw new Error(error || '')
		}
	}
}

export const setCancelOpenAction = (tradeId, accessToken, isAuthorized, alert) => {
	return async dispatch => {
		try {
			const res = await api.orders.setCancelOpen(tradeId, accessToken)
			if (res.data) {
				dispatch(setSidebarIsOpen(false))
				dispatch(getPositionsData(isAuthorized, accessToken, alert))
			}
			return res.data
		} catch (e) {
			const error = executeResponseError(e, 'Set close open order error')
			throw new Error(error || '')
		}
	}
}

export const setStateStopLoss = (data) => {
	return {
		payload: data,
		type: ORDER_SET_STOP_LOSS
	}
}
export const setLotAction = (lot) => {
	return {
		payload: lot,
		type: ORDER_SET_LOT
	}
}

export const setStateTakeProfit = (data) => {
	return{
		payload: data,
		type: ORDER_SET_TAKE_PROFIT
	}
}

export const setTpLine = (data) => {
	return{
		payload: data,
		type: ORDER_SET_TP_LINE
	}
}

export const setSlLine = (data) => {
	return{
		payload: data,
		type: ORDER_SET_SL_LINE
	}
}

export const setPipValue = (data) => {
	return {
		payload: data,
		type: ORDER_SET_PIP
	}
}

export const setUsedMargin = (data) => {
	return {
		payload: data,
		type: ORDER_SET_USED_MARGIN
	}
}
